// Lib
import React, { ReactElement } from 'react';

// Components
import ElementExportPopupButton from './ElementExportPopupButton';

// Constants
import { MimeType } from '../../../common/media/mimeConstants';
import { BoardExportFormat, BoardExportQuality } from '../../../common/export/exportConstants';
import { FILE_TYPES_INFO } from '../../../common/files/fileConstants';

// Styles
import './ExportPopup.scss';

// Types
import { TranslateFunction } from '../../components/i18n/types';

type Props = {
    elementId: string;
    translate: TranslateFunction;
};

const ExportPopupForDocumentModal = ({ elementId, translate }: Props): ReactElement => (
    <div className="ExportPopup">
        <div className="export-section">
            <div className="export-options">
                <h3>{translate('export.title')}...</h3>
                <ElementExportPopupButton
                    elementId={elementId}
                    mimeType={MimeType.PDF}
                    fileType={FILE_TYPES_INFO.PDF.type}
                    format={BoardExportFormat.linear}
                    quality={BoardExportQuality.high}
                >
                    {translate('export.format.pdf')}
                </ElementExportPopupButton>
                <ElementExportPopupButton
                    elementId={elementId}
                    mimeType={MimeType.DOCX}
                    fileType={FILE_TYPES_INFO.DOCX.type}
                    format={BoardExportFormat.linear}
                >
                    {translate('export.format.word')}
                </ElementExportPopupButton>
                <ElementExportPopupButton
                    elementId={elementId}
                    mimeType={MimeType.MARKDOWN}
                    fileType={FILE_TYPES_INFO.TEXT.type}
                    format={BoardExportFormat.linear}
                >
                    {translate('export.format.markdown')}
                </ElementExportPopupButton>
                <ElementExportPopupButton
                    elementId={elementId}
                    mimeType={MimeType.PLAIN_TEXT}
                    fileType={FILE_TYPES_INFO.TEXT.type}
                    format={BoardExportFormat.linear}
                >
                    {translate('export.format.plainText')}
                </ElementExportPopupButton>
            </div>
        </div>
    </div>
);

export default ExportPopupForDocumentModal;
